module.exports = __webpack_public_path__ + "img/blog.2b205f19.png";